// extracted by mini-css-extract-plugin
export default {"titleSmall":"TitleSmall_titleSmall__6GbY-"};